// @ts-check
// ====== Eventi critici → notifiche IN-APP per tutti gli admin ======
// (Sostituisce il webhook Teams/Slack: nessuna email/notifica esterna).
// Quando l'utente esegue un'azione critica, viene creata una notifica per ogni admin.

const CRITICAL_EVENT_TITLES = {
  'cliente.deleted': { title: '🗑 Cliente eliminato', priority: 'warning' },
  'backup.restored': { title: '↺ Backup ripristinato', priority: 'critical' },
  'utente.deleted': { title: '👤 Utente rimosso', priority: 'warning' },
  'storico.cleared': { title: '📜 Storico audit svuotato', priority: 'warning' },
  'bulk.update': { title: '🔁 Modifica massiva accessi', priority: 'info' }
};

async function notifyCritical(event, payload) {
  try {
    const meta = CRITICAL_EVENT_TITLES[event] || { title: event, priority: 'info' };
    const actor = getCurrentUser?.();
    const parts = [];
    if (payload) {
      Object.entries(payload).forEach(([k, v]) => {
        if (v === null || v === undefined) return;
        const sv = typeof v === 'object' ? JSON.stringify(v) : String(v);
        parts.push(`${k}: ${sv}`);
      });
    }
    const body =
      (actor ? `Da: ${actor.name}` : 'Sistema') + (parts.length ? ' · ' + parts.join(' · ') : '');
    await notifApi.notifyAdmins(event, meta.title, body, payload || {}, meta.priority);
  } catch (e) {
    console.warn('notifyCritical skipped:', e.message || e);
  }
}

globalThis.notifyCritical = notifyCritical;
export {};
